<template>
    <div :class="['poptipBox',{poptipLeftBox: widthVFun}]" :style="styles">
        <div class="popImg" @click="routeClick(itemObj)">
            <img :src="headImg(itemObj.headPortrait)"
                 onerror="this.onerror=null; this.src='images/default-cover/default_user.png'"></div>
        <div class="popText" @click="routeClick(itemObj)">
            <h3 class="h3">{{ itemObj.memberName }}</h3>
            <div class="graImg" v-if="dataObj.integralGrade && (dataObj.integralGrade.cover || dataObj.integralGrade.gradeName)">
                <img :src="medalImg(dataObj.integralGrade.cover)">
                <span :title="dataObj.integralGrade.gradeName">{{ dataObj.integralGrade.gradeName | cutstring }}</span>
            </div>
            <!-- <p :title="detailObj.organization.name">组织：{{ detailObj.organization.name }}</p > -->
            <a-tooltip placement="bottomLeft" @visibleChange="visibleChange(popObj.orgId)">
                <template slot="title">
                    <span>{{ organizationName }}</span>
                    <!-- <span>{{ intTextMouse(item.orgId) }}</span> -->
                </template>
                <p class="intTextClass">{{ detailObj.organization.name }}</p >
            </a-tooltip>
            <p>身份：{{ textName() }}</p >
            <p>学习时长：{{ timeFun }}</p >
        </div>
    </div>
</template>
<script>
    import findPath from '@/mixins/findPath';
    import { gradeAPI, detailApi, studyTimeApi, otherSimpleApi, lectureApi, teacherApi } from '@/store/api/home';
    import { secondToDate } from '@/assets/js/myApp';

    export default {
        mixins: [findPath],
        props: {
            iconRight: {
                type: Boolean,
                default: false
            },
            clientY: {
                type: Number,
                default: null
            },
            popObj: {
                type: [Object, String],
                default: {}
            },
            isObj: {
                type: Object,
                default: {}
            },
            clientX: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                itemObj: {},
                isSimple: false, // 是否专家
                isLecture: null, // 是否讲师
                isTeacher: null, // 是否班务
                dataObj: {
                    integralGrade: {}
                }, // 个人名片
                detailObj: {
                    organization: {}
                }, // 个人所在组织
                studyTimeObj: {}, // 时长对象
            };
        },
        computed: {
            timeFun() {
                // console.log(this.studyTimeObj);
                let s = this.studyTimeObj[0] + this.studyTimeObj[1];
                if (this.studyTimeObj[2]) {
                    s += this.studyTimeObj[2];
                }
                // console.log(s);
                return secondToDate(this, s);
            },
            numBool() {
                return this.isObj.type === 4 || this.isObj.type === 3 || this.isObj.type === 5 || this.isObj.type === 1 || this.isObj.type === 2;
            },
            widthVFun() {
                if (this.iconRight) return true;
                if (document.documentElement) {
                    const widthV = document.documentElement.clientWidth;
                    return widthV < this.clientX + 320;
                }
                return false;
            },
            styles() {
                if (this.widthVFun) {
                    return {
                        top: `${this.clientY}px`,
                        left: `${this.clientX - 320}px`
                    };
                }
                return {
                    top: `${this.clientY}px`,
                    left: `${this.clientX}px`
                };
            }
        },
        watch: {
            popObj(val) {
                if (val.memberId) {
                    // this.styles();
                    this.apiFun(val.memberId);
                    this.itemObj = val;
                }
            }
        },
        methods: {
            medalImg(img) {
                if (!img) return 'images/default-cover/default_medal.jpg';
                return img;
            },
            routeClick(item) {
                if (item.memberId && this.numBool) {
                    window.open(`#/personal-homepage/${item.memberId}`);
                }
                if (this.isObj.type === 8) {
                    window.open(`#/ask/question/detail/${item.id}`);
                }
                if (this.isObj.type === 7) {
                    window.open(`#/ask/topic/detail/${item.id}`);
                }
                if (this.isObj.type === 6) {
                    window.open(`#/knowledge/detail/${item.id}`);
                }
            },
            textName() {
                let text = '';
                if (this.isSimple) {
                    text += '专家 ';
                }
                if (this.isLecture) {
                    text += '讲师 ';
                }
                if (this.isTeacher) {
                    text += '班务';
                }
                if (!text) {
                    text = '普通用户';
                }
                return text;
            },
            headImg(img) {
                if (img) return img;
                return 'images/default-cover/default_user.png';
            },
            apiFun(memberId) {
                const data = { memberId };
                gradeAPI(data).then((res) => {
                    this.dataObj = res.data;
                });
                detailApi(data).then((res) => {
                    this.detailObj = res.data;
                });
                studyTimeApi(data).then((res) => {
                    this.studyTimeObj = res.data.studyTime;
                });
                otherSimpleApi(data).then((res) => {
                    if (res.data && res.data.activeStatus === 1 && res.data.auditStatus === 1) {
                        this.isSimple = true;
                    } else {
                        this.isSimple = false;
                    }
                });
                lectureApi(data).then((res) => {
                    this.isLecture = res.data;
                });
                teacherApi(data).then((res) => {
                    this.isTeacher = res.data;
                });
            },
            // widthVFun() {
            //     if (document.documentElement) {
            //         const widthV = document.documentElement.clientWidth;
            //         return widthV < this.clientX + 320;
            //     }
            //     return false;
            // },
            // styles() {
            //     const isRightBox = this.widthVFun();
            //     if (isRightBox) {
            //         window.jQuery('.poptipBox').addClass('poptipLeftBox');
            //         window.jQuery('.poptipBox').css({
            //             top: `${this.clientY}px`,
            //             left: `${this.clientX - 320}px`
            //         });
            //     } else {
            //         window.jQuery('.poptipBox').removeClass('poptipLeftBox');
            //         window.jQuery('.poptipBox').css({
            //             top: `${this.clientY}px`,
            //             left: `${this.clientX}px`
            //         });
            //     }
            // }
        }
    };
</script>
